export default __webpack_public_path__ + "37406c816cea74277364f41afaca73ea.svg";